import { Component, OnInit } from '@angular/core';
import { BreadCrumbsService } from '../../../services/bread-crumbs/bread-crumbs.service';

@Component({
  selector: 'app-mf-breadcrumbs',
  templateUrl: './mf-breadcrumbs.component.html',
  styleUrls: ['./mf-breadcrumbs.component.css']
})
export class MfBreadcrumbsComponent implements OnInit {
  constructor(public breadCrumbService: BreadCrumbsService) { }

  ngOnInit() {
  }

  public navigate(item) {
    var self = this;
    if (item.command) {
      item.command(item);
     
    }
  }

  public showLabel(item) {
    //if (item.label) alert(item.label);
  }
}
